var CryptoJS = require("crypto-js");
let secretKey = process.env.NEXT_PUBLIC_SECRET_KEY;

const setEncryptedCookie = (name: string, value: string, days: number) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  let encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();
  document.cookie = `${name}=${encryptedValue || ""}${expires}; path=/`;
}

const getEncryptedCookies = (name: string) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      let value = c.substring(nameEQ.length, c.length);
      return CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
    }
  }
  return null;
}

const setCrypto = (value: any) => {
  // Verificar si el valor es un objeto o una matriz
  if (typeof value === 'object' && value !== null) {
    // Convertir el objeto o la matriz en una cadena JSON antes de encriptar
    value = JSON.stringify(value);
  }
  if(value.length === 0) return value;
  if(value.length > 0) {
    // Encriptar el valor utilizando AES
    return CryptoJS.AES.encrypt(value, secretKey).toString();
  }
  
  // Encriptar el valor utilizando AES
  return CryptoJS.AES.encrypt(value, secretKey).toString();
}


const desCrypto = (value: string) => {
  // Desencriptar el valor utilizando AES
  let decryptedValue = CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
  
  // Verificar si el valor es una cadena JSON
  if (decryptedValue) {
    try {
      // Intentar convertir la cadena JSON en un objeto o una matriz
      return JSON.parse(decryptedValue);
    } catch (error) {
      // Si no se puede convertir la cadena JSON, devolver el valor desencriptado
      return decryptedValue;
    }
  }
  
  // Si no se puede desencriptar el valor, devolver el valor original
  return value;
}

export { setEncryptedCookie, getEncryptedCookies, desCrypto, setCrypto };